import { isWeekend, startOfYear, endOfYear } from "date-fns";

export const getCurrentYearDateRange = (): { start: string; end: string } => {
  const now = new Date();
  const yearStart = startOfYear(now);
  const yearEnd = endOfYear(now);
  return {
    start: yearStart.toISOString().split('T')[0],
    end: yearEnd.toISOString().split('T')[0]
  };
};

export const isVacationInCurrentYear = (startDate: string): boolean => {
  const vacationYear = new Date(startDate).getFullYear();
  const currentYear = new Date().getFullYear();
  return vacationYear === currentYear;
};

export const calculateBusinessDays = (startDate: Date, endDate: Date): number => {
  let count = 0;
  const currentDate = new Date(startDate);
  
  while (currentDate <= endDate) {
    if (!isWeekend(currentDate)) {
      count++;
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return count;
};